
<MobileDrawer
    :isVisible="show"
    :title="drawerTitle"
    :closeOnOverlay="true"
    :swipeToClose="true"
    :maxHeight="'75vh'"
    @close="handleClose"
>
    <div v-if="isIOS" class="pwa-prompt-content">
        <div class="pwa-prompt-icon">
            <i class="ri-smartphone-line"></i>
        </div>

        <p class="pwa-prompt-description">Für schnellen Zugriff direkt vom Homescreen:</p>

        <div class="pwa-prompt-steps">
            <div class="pwa-prompt-step">
                <div class="step-number">1</div>
                <div class="step-content">
                    <strong>Tippe auf das Teilen-Symbol</strong>
                    <span class="step-hint"
                        ><i class="ri-share-2-line"></i> in der unteren Leiste</span
                    >
                </div>
            </div>

            <div class="pwa-prompt-step">
                <div class="step-number">2</div>
                <div class="step-content">
                    <strong>Scrolle runter und wähle</strong>
                    <span class="step-hint">"Zum Home-Bildschirm hinzufügen"</span>
                </div>
            </div>

            <div class="pwa-prompt-step">
                <div class="step-number">3</div>
                <div class="step-content">
                    <strong>Tippe auf "Hinzufügen"</strong>
                </div>
            </div>
        </div>

        <div class="pwa-prompt-benefits">
            <div class="benefit-item">
                <i class="ri-checkbox-circle-line"></i>
                <span>Offline verfügbar</span>
            </div>
            <div class="benefit-item">
                <i class="ri-checkbox-circle-line"></i>
                <span>Push-Benachrichtigungen</span>
            </div>
            <div class="benefit-item">
                <i class="ri-checkbox-circle-line"></i>
                <span>Schnellerer Start</span>
            </div>
        </div>

        <div class="pwa-prompt-actions">
            <Button variant="success" size="large" @onClick="handleUnderstood">
                Alles klar!
            </Button>
            <Button variant="plain" size="small" @onClick="handleDontShowAgain">
                Nicht mehr anzeigen
            </Button>
        </div>
    </div>

    <div v-else-if="isAndroid && canInstall" class="pwa-prompt-content">
        <div class="pwa-prompt-icon">
            <i class="ri-smartphone-line"></i>
        </div>

        <p class="pwa-prompt-description">Installiere TaxiFusion für:</p>

        <div class="pwa-prompt-benefits">
            <div class="benefit-item">
                <i class="ri-checkbox-circle-line"></i>
                <span>Schnelleren Zugriff</span>
            </div>
            <div class="benefit-item">
                <i class="ri-checkbox-circle-line"></i>
                <span>Offline-Nutzung</span>
            </div>
            <div class="benefit-item">
                <i class="ri-checkbox-circle-line"></i>
                <span>Benachrichtigungen</span>
            </div>
        </div>

        <div class="pwa-prompt-actions">
            <Button
                variant="success"
                size="large"
                @onClick="handleInstall"
                :isLoading="isInstalling"
            >
                Installieren
            </Button>
            <Button variant="plain" size="small" @onClick="handleDismiss"> Nein danke </Button>
        </div>
    </div>

    <div v-else-if="isAndroid && !canInstall" class="pwa-prompt-content">
        <div class="pwa-prompt-icon">
            <i class="ri-smartphone-line"></i>
        </div>

        <p class="pwa-prompt-description">Installiere TaxiFusion für schnellen Zugriff:</p>

        <div class="pwa-prompt-steps">
            <div class="pwa-prompt-step">
                <div class="step-number">1</div>
                <div class="step-content">
                    <strong>Tippe auf das Menü-Symbol</strong>
                    <span class="step-hint"
                        ><i class="ri-more-2-fill"></i> oben rechts im Browser</span
                    >
                </div>
            </div>

            <div class="pwa-prompt-step">
                <div class="step-number">2</div>
                <div class="step-content">
                    <strong>Wähle "Zum Startbildschirm hinzufügen"</strong>
                    <span class="step-hint">oder "App installieren"</span>
                </div>
            </div>

            <div class="pwa-prompt-step">
                <div class="step-number">3</div>
                <div class="step-content">
                    <strong>Bestätige die Installation</strong>
                </div>
            </div>
        </div>

        <div class="pwa-prompt-benefits">
            <div class="benefit-item">
                <i class="ri-checkbox-circle-line"></i>
                <span>Schnellerer Zugriff</span>
            </div>
            <div class="benefit-item">
                <i class="ri-checkbox-circle-line"></i>
                <span>Offline-Nutzung</span>
            </div>
            <div class="benefit-item">
                <i class="ri-checkbox-circle-line"></i>
                <span>Benachrichtigungen</span>
            </div>
        </div>

        <div class="pwa-prompt-actions">
            <Button variant="success" size="large" @onClick="handleUnderstood">
                Alles klar!
            </Button>
            <Button variant="plain" size="small" @onClick="handleDontShowAgain">
                Nicht mehr anzeigen
            </Button>
        </div>
    </div>
</MobileDrawer>
